import * as Sentry from "@sentry/react";
import Carousel from "../components/Carousel";
import CustomLink from "../components/CustomLink";
import Footer from "../components/Footer";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import ProjectList from "../components/ProjectList";
import styles from "./HomePage.module.css";

export default function Home({ coreData, pageData, pathName }) {
  return (
    <Layout coreData={coreData} theme="dark" pathName={pathName}>
      <div>
        <div className={styles.introSection}>
          <Heading className={styles.introHeading}>
            {pageData.introText}
          </Heading>
          <div className={styles.cta}>
            <CustomLink href={coreData.projectListPage.url}>
              View our work
            </CustomLink>
          </div>
        </div>
        <div className={styles.carouselSection}>
          <Carousel
            className={styles.carousel}
            items={pageData.carouselItems}
          />
        </div>
        <div className={styles.projectListSection}>
          <ProjectList
            projectPages={pageData.projectListItems}
            className={styles.projectList}
            imageBackgroundColor="var(--off-dark)"
          />
        </div>
        <div className={styles.aboutSection}>
          <Heading className={styles.aboutHeading}>
            {pageData.aboutText}
          </Heading>
          <div className={styles.cta}>
            <CustomLink href={coreData.aboutPage.url}>About us</CustomLink>
          </div>
        </div>
      </div>
      <Footer theme="dark" />
    </Layout>
  );
}
